<!-- eslint-disable vue/max-len -->
<template>
  <svg
    v-if="direction === 'up'"
    v-bind="$attrs"
    :class="`chevron chevron-up color-fill-${color}`"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.4 15.375L6 13.975L12 7.97498L18 13.975L16.6 15.375L12 10.775L7.4 15.375Z" />
  </svg>
  <svg
    v-else-if="direction === 'right'"
    v-bind="$attrs"
    :class="`chevron chevron-right color-fill-${color}`"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" />
  </svg>
  <svg
    v-else-if="direction === 'down'"
    v-bind="$attrs"
    :class="`chevron chevron-down color-fill-${color}`"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 15.375L6 9.37498L7.4 7.97498L12 12.575L16.6 7.97498L18 9.37498L12 15.375Z" />
  </svg>
  <svg
    v-else
    v-bind="$attrs"
    :class="`chevron chevron-left color-fill-${color}`"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
  direction: 'up' | 'right' | 'down' | 'left';
  width?: string;
  height?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
  width: '24',
  height: '24',
});
</script>
